module.exports = __webpack_public_path__ + "static/media/0_2019_06_29-1.b2444ad1.jpg";